var _path, _rect, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2035 6.91585C22.0568 6.9403 21.9101 7.01365 21.7878 7.087L17.9735 9.28757V14.9601L21.8123 17.1607C22.5213 17.5764 23.4016 17.3319 23.8172 16.6228C23.9395 16.4027 24.0128 16.1582 24.0128 15.8893V8.33399C24.0128 7.42931 23.1571 6.69579 22.2035 6.91585Z",
    fill: "#F2F2F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.76489,
    y: 0.407715,
    width: 24.7505,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(60 5.76489 0.407715)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18395 5.55493H3.43226C2.08747 5.55493 0.987183 6.65521 0.987183 8.00001V16.2399C0.987183 17.5847 2.08747 18.685 3.43226 18.685H12.7646L5.18395 5.55493ZM15.0632 18.2165C15.6743 17.7708 16.0733 17.0497 16.0733 16.2399V8.00001C16.0733 6.63076 14.973 5.55493 13.6282 5.55493H7.75307L15.0632 18.2165Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.168 15.804L3.43224 15.804C2.08746 15.804 0.987183 14.7281 0.987183 13.3589V16.2401C0.987183 17.6093 2.08746 18.6851 3.43224 18.6851L12.8314 18.6851L11.168 15.804ZM14.4756 18.5328C15.406 18.1863 16.0733 17.2873 16.0733 16.2401V13.3589C16.0733 14.7037 14.973 15.804 13.6282 15.804H12.9L14.4756 18.5328Z",
    fill: "black",
    fillOpacity: 0.15
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/camera-off.cea9a7f5.svg";
export { ForwardRef as ReactComponent };